let Kruxinit = {
  'site': window.vocento.tracking.comscore.ns_site,
  'section': window.vocento.tracking.comscore.voc_se,
  'subsection': window.vocento.tracking.comscore.voc_s1,
  'type': window.vocento.tracking.comscore.voc_tc
};

DigitalContext.init(Kruxinit);
window.context = DigitalContext.getContext();




// WEBPACK FOOTER //
// ./src/tracking/stats.js